import { isAuthenticated } from '../utils/authHelper';
import React from 'react';
import { MuiThemeProvider } from '@material-ui/core/styles'
import Snackbar from '@material-ui/core/Snackbar';
import Delete from '@material-ui/icons/Delete'
import Info from '@material-ui/icons/Visibility'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Button from '@material-ui/core/Button';
import Edit from '@material-ui/icons/Edit'
import Table from './VendorListtable'
import { browserHistory } from 'react-router'
import Header from './Header'
import { getPendingVendors, deletePendingVendors } from '../utils/VendorApiUtils'
class PendingApproval extends React.Component {
  constructor(props) {
    super(props)
    if (!isAuthenticated()) {
      browserHistory.push('/')
    }
    this.state = {
      state: 'pending',
      value: 0,
      data: undefined,
      dialogBox: false,
      index: '',
      status: '',
      snackOpen: false,
      snackText: '',
    }

  }
  componentDidMount() {
    getPendingVendors().then((response) => {
      if (response) {
        if (response.status === 'success') {
          let vendorData
          let pending = response.data.map((data, index) => {
            if(data.vendors && data.vendors.vendor_agreement) {
              data.vendors.agreement_expiry_date = data.vendors.agreement_expiry_date ? new Date(data.vendors.agreement_expiry_date) : null;
              data.vendors.vendor_agreement = String(data.vendors.vendor_agreement);
            }
            if(data.vendors && data.vendors.vendor_ldc_agreement) {
              data.vendors.ldc_agreement_start_date = data.vendors.ldc_agreement_start_date ? new Date(data.vendors.ldc_agreement_start_date) : null;
              data.vendors.ldc_agreement_end_date = data.vendors.ldc_agreement_end_date ? new Date(data.vendors.ldc_agreement_end_date) : null;
              data.vendors.vendor_ldc_agreement = String(data.vendors.vendor_ldc_agreement);
            }
            if (window.location.pathname === '/vendor/approval') {
              vendorData = {
                ...data, ...data.vendors, ...data.acc_details[0], ...data.addresses[0],
                preview: <div>
                  <Info style={{ cursor: 'pointer' }} onClick={this.handleApproval.bind(this, 'info', data)} /></div>
              }
            }
            else {
              vendorData = {
                ...data, ...data.vendors, ...data.acc_details[0], ...data.addresses[0],
                agreement_expiry_date: data.vendors.agreement_expiry_date ? new Date(data.vendors.agreement_expiry_date) : null,
                ldc_agreement_start_date: data.vendors.ldc_agreement_start_date ? new Date(data.vendors.ldc_agreement_start_date) : null,
                preview: <div>
                  <Info style={{ cursor: 'pointer' }} onClick={this.handleClick.bind(this, 'info', index)} />
                  <Edit style={{ marginLeft: '20px', cursor: 'pointer' }} onClick={this.handleClick.bind(this, 'edit', index)} />
                  {/* 
                    //? Note: Deleting a request from the 'Pending Vendors' page will also remove the vendor from the 'Verified Vendors' page. This is because the vendor data in the 'transaction_log' table remains in a 'pending' state, but the status changes to '0', indicating that the request has been deleted. It's also important to note that the delete button on the 'Pending Vendors' page is not typically used. 
                  */}
                  {/* <Delete style={{ marginLeft: '20px', cursor: 'pointer' }} onClick={this.handleDelete.bind(this, index)} /> */}
                  </div>
              }
            }
            delete vendorData.vendors
            delete vendorData.acc_details
            delete vendorData.addresses
            return vendorData
          })
          this.setState({ data: pending, state: 'pending' })
        }

        else if (response.status === 'failure') {
          this.setState({ dialogBox: true, dialogBoxText: response.message })
        }
      }
    })
  }
  handleDelete(index, value, event) {
    this.setState({
      dialogBox: true,
      index,
      status: value
    })
  }
  handleApproval(value, data, event) {
    let vendorData = { 
      ...data, 
      ...data.vendors,
      agreement_expiry_date: data.vendors.agreement_expiry_date ? new Date(data.vendors.agreement_expiry_date) : null,
      ldc_agreement_start_date: data.vendors.ldc_agreement_start_date ? new Date(data.vendors.ldc_agreement_start_date) : null,
      ...data.acc_details[0], 
      ...data.addresses[0] 
    }
    delete vendorData.vendors
    delete vendorData.acc_details
    delete vendorData.addresses
    browserHistory.push({
      pathname: '/vendor/approval-preview',
      state: { ...vendorData, state: value }
    })
  }
  handleYes() {
    deletePendingVendors(JSON.stringify({ 'transaction_id': this.state.data[this.state.index].transaction_id }))
      .then((response) => {
        if (response) {
          if (response.status === 'success') {
            let pending = this.state.data.filter((data, index) => {
              return index !== this.state.index
            })
            let vendorData
            pending = pending.map((data, index) => {
              if (window.location.pathname === '/vendor/approval') {
                vendorData = {
                  ...data,
                  preview: <div>
                    <Info style={{ cursor: 'pointer' }} onClick={this.handleApproval.bind(this, 'info', data)} /></div>
                }
              }
              else {
                vendorData = {
                  ...data,
                  preview: <div>
                    <Info style={{ cursor: 'pointer' }} onClick={this.handleClick.bind(this, 'info', index)} />
                    <Edit style={{ marginLeft: '20px', cursor: 'pointer' }} onClick={this.handleClick.bind(this, 'edit', index)} />
                    <Delete style={{ marginLeft: '20px', cursor: 'pointer' }} onClick={this.handleDelete.bind(this, index)} /></div>
                }
              }
              return vendorData
            })
            this.setState({ data: pending, dialogBox: false })
          }

          else if (response.status === 'failure') {
            this.setState({ dialogBox: true, dialogBoxText: response.message })
          }
        }
      })
  }
  handleCloseSnack() {
    this.setState({ snackOpen: false, snackText: '' })
  }
  handleNo() {
    this.setState({ dialogBox: false })
  }
  handleClick(value, index, event) {
    let data = this.state.data[index]
    if (value === 'edit') {
      let vendorBasicDetais = {
        name: data.name,
        contact_person_name: data.contact_person_name,
        address: data.address,
        city_name: data.city_name,
        city_id: data.city_id,
        state_name: data.state_name,
        contact_number: data.contact_number,
        alternate_contact_number: data.alternate_contact_number,
        email_id: data.email_id,
        transaction_id: data.transaction_id,
        transaction_pointer: data.transaction_pointer,
        transaction_state: data.transaction_state,
        vendor_buffer_id: data.vendor_buffer_id,
        status: data.status,
        national: data.national,
        transaction_type: data.transaction_type
      }
      let vendorFinancialDetails = {
        payment_mode: data.payment_mode,
        beneficiary_name: data.beneficiary_name,
        bank_acc_number: data.bank_acc_number,
        ifsc_code: data.ifsc_code,
        bank_name: data.bank_name,
        cancel_cheque_upload_file: data.cancel_cheque_upload_file,
        cancel_cheque_upload_file_name: data.cancel_cheque_upload_file_name,
        tds_liability: data.tds_liability,
        tds_liability_remarks: data.tds_liability_remarks,
        confirm_bank_acc_number: data.bank_acc_number,
        pancard_number: data.pancard_number,
        pancard_scan_copy: data.pancard_scan_copy,
        pancard_file_name: data.pancard_file_name,
        pancard_status: data.pancard_status,
        aadhar_number: data.aadhar_number,
        aadhar_scan_copy: data.aadhar_scan_copy,
        aadhar_file_name: data.aadhar_file_name,
        company_category: data.company_category,
        contractual_terms: data.contractual_terms,
        central_finance_remarks: data.central_finance_remarks,
        city_finance_remarks: data.city_finance_remarks,
        trade_licence_file_name: data.trade_licence_file_name,
        trade_licence_file: data.trade_licence_file,
        msme_vendor: data.msme_vendor,
        msme_certificate: data.msme_certificate,
        msme_certificate_file_name: data.msme_certificate_file_name,
        vendor_agreement: data.vendor_agreement,
        agreement_expiry_date: data.agreement_expiry_date ? new Date(data.agreement_expiry_date) : null,
        vendor_agreement_file_name: data.vendor_agreement_file_name,
        defaultor_amount: data.defaultor_amount,
        vendor_ldc_agreement: String(data.vendor_ldc_agreement == '1' || data.vendor_ldc_agreement == '0' ? data.vendor_ldc_agreement : ''),
        ldc_agreement_start_date: data.ldc_agreement_start_date ? new Date(data.ldc_agreement_start_date) : null,
        ldc_agreement_end_date: data.ldc_agreement_end_date ? new Date(data.ldc_agreement_end_date) : null,
        vendor_ldc_agreement_file_name: data.vendor_ldc_agreement_file_name,
        ldc_tds_rate_data: data.ldc_tds_rate_data,
      }
      let vendorGstDetails = {
        gstn: data.gstn,
        gstn_verified: data.gstn_verified,
        gstn_verification_remarks: data.gstn_verification_remarks,
        gstn_status: data.gstn_status,
        legal_name: data.legal_name,
        entity_type: data.entity_type,
        registration_type: data.registration_type,
        department_code: data.department_code,
        nature_of_business: data.nature_of_business,
        registration_date: data.registration_date
      }
      browserHistory.push({
        pathname: '/vendor/pending/edit',
        state: { vendorBasicDetais, vendorGstDetails, vendorFinancialDetails, state: value }
      })
    }
    if (value === 'info') {
      browserHistory.push({
        pathname: '/vendor/pending/info',
        state: { ...data, state: value }
      })
    }
  }
  render() {
    return (
      <MuiThemeProvider>
        <Header />
        <div className="zaps-page-wrap">
          <div className="zaps-page-header">
            <div>
              <h2 className="zaps-page-title">Pending Vendors</h2>
              <p className="zaps-page-subtitle">Review and manage vendor approval requests</p>
            </div>
          </div>
          {this.state.data !== undefined && <Table data={this.state.data} status='pending' />}
          <Dialog
            open={this.state.dialogBox}
            onClose={this.handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Are you sure you want to delete this request
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleNo.bind(this)} color="primary">
                No
              </Button>
              <Button onClick={this.handleYes.bind(this)} color="primary" autoFocus>
                Yes
              </Button>
            </DialogActions>
          </Dialog>
          <Snackbar
            open={this.state.snackOpen}
            autoHideDuration={1000}
            onClose={this.handleCloseSnack.bind(this)}
            message={this.state.snackText}
          />
        </div>{/* end zaps-page-wrap */}
      </MuiThemeProvider>
    )
  }
}
export default PendingApproval



// WEBPACK FOOTER //
// ./src/components/PendingVendors.js